import CookieStorage from './CookieStorage';

/**
 * Checks for the ability to use localStorage, and if it fails, attempts to use
 * cookies instead.
 *
 * You must still check that LocalStorage is available before using it because
 * if the user has disabled cookies and storage, LocalStorage will be undefined.
 *
 * Basic usage:
 * Import LocalStorage:
 *     import { LocalStorage } from 'sarsaparilla';
 *
 * Then in your React class, use LocalStorage in the same way you would use
 * window.localStorage. It has the same methods as window.localStorage.
 *
 * Example:
 *     LocalStorage.setItem('myDog', 'Pearl');
 *     console.log(LocalStorage.getItem('myDog')); // > 'Pearl'
 */

/* eslint-disable no-console */

function createLocalStorage() {
    // 1. Test if we can use localStorage
    try {
        window.localStorage.setItem('test', 1);
        window.localStorage.removeItem('test');
        return window.localStorage;
    }
    catch (e) {
        console.warn('localStorage is not available. Trying sessionStorage');
    }

    // 2. Test if tempLocalStorage has already been initialized
    if (window.tempLocalStorage) {
        return window.tempLocalStorage;
    }

    // 3. Test if we can use cookies
    try {
        // Create cookie
        document.cookie = 'cookietest=1';
        // Delete cookie
        document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
        window.tempLocalStorage = new CookieStorage();
        return window.tempLocalStorage;
    }
    catch (e) {
        console.warn('Cookies are not available. Switching to temp storage');
    }

    // 4. return undefined because nothing is available
    return undefined;
}

const LocalStorage = createLocalStorage();

export default LocalStorage;
